import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApContentPipe, ApContentComponent } from '@ap/content';
import { ApModalComponent } from '@ap/modal';
import { ApNotificationComponent } from '@ap/notification';

import { NoAvailableTokensModalComponent } from './no-available-tokens-modal.component';

/**
 * @ngdoc module
 * @name NoAvailableTokensModalModule
 **/
@NgModule({
    declarations: [NoAvailableTokensModalComponent],
    imports: [ApContentPipe, ApContentComponent, ApModalComponent, ApNotificationComponent, CommonModule]
})
export class NoAvailableTokensModalModule {}
